import Vue from 'vue'
import Vuex from 'vuex'
import { keys } from '../utils/messages'
import * as actions from './actions'
import validate from './validate'
import validateTenancy from './validateTenancy'
import user from './modules/system/user'
import role from './modules/system/role'
import view from './modules/system/view'
import features from './modules/system/features'
import calibrationTips from './modules/system/calibrationTips'
import menu from './modules/system/menu'
import ioam from './modules/ioam'
import person from './modules/system/person'
import organization from './modules/system/organization'
import place from './modules/system/place'
import tenancy from './modules/system/tenancy'
import feedback from './modules/system/feedback'
import carousel from './modules/system/carousel'
import application from './modules/system/application'
import data from './modules/system/data'
import stationScreen from './modules/system/stationScreen'
import phoneCode from './modules/system/phoneCode'
import device from './modules/system/device'
import deviceActions from './modules/system/deviceActions'
Vue.use(Vuex)

let actionsAll = {
  ...actions
}
actionsAll[keys.appMsg] = ({commit}, payload) => { }
actionsAll[keys.organization.update] = ({commit}, payload) => { }
actionsAll[keys.organization.refreshParent] = ({commit}, payload) => { }
actionsAll[keys.account.update] = ({commit}, payload) => { }

let mutationsAll = { }
mutationsAll[keys.appMsg] = (state, payload) => { }
mutationsAll[keys.organization.update] = (state, payload) => { }
mutationsAll[keys.organization.refreshParent] = (state, payload) => { }
mutationsAll['setws'] = (state, payload) => {
  state.ws.push(payload)
}
mutationsAll['setinter'] = (state, payload) => {
  state.interval.push(payload)
}

export default new Vuex.Store({
  mutations: mutationsAll,
  modules: {
    validate,
    validateTenancy,
    user,
    role,
    view,
    features,
    calibrationTips,
    menu,
    ioam,
    person,
    phoneCode,
    organization,
    place,
    tenancy,
    feedback,
    carousel,
    application,
    data,
    stationScreen,
    device,
    deviceActions
  },
  actions: actionsAll,
  state: {
    ws: [],
    interval: []
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js